import { IconComponent } from './types';

const LinkIcon: IconComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.632 5.28h1.593a2.72 2.72 0 1 1 0 5.44H9.632M6.368 10.72H4.775a2.72 2.72 0 1 1 0-5.44h1.593M10.176 8H5.824"
    />
  </svg>
);
export default LinkIcon;
